import React from 'react'
import PropTypes from 'prop-types'

import {
  UserAssignmentCheckbox,
  UserAssignmentSelect,
} from '../../../common/components/sections'
import { PERMISSIONS, USER_ASSIGNMENT_LABEL } from '../../../common/constants'

import { useUserHasPermissions } from '../../../account/hooks'
import { useAssignUserToMenuCurationTaskMutation } from '../../hooks'

const MenuCurationTaskUserAssignment = ({
  menuCurationTaskId,
  userActionType,
  tooltip,
  otherAssignedUsers,
  assignedUser,
  isCheckbox,
  unassignedLabel,
  isDisabled,
}) => {
  const [assignUser] = useAssignUserToMenuCurationTaskMutation(
    menuCurationTaskId,
    userActionType,
  )

  const hasPermissionToAssignCurrentUser = useUserHasPermissions(
    PERMISSIONS.MENU_CURATION_TASK.ASSIGN_USER,
  )

  const hasPermissionToAssignOtherUsers = useUserHasPermissions(
    PERMISSIONS.MENU_CURATION_TASK.ASSIGN_USERS,
  )

  if (isCheckbox || !hasPermissionToAssignOtherUsers) {
    return (
      <div>
        <UserAssignmentCheckbox
          tooltip={tooltip}
          assignedUser={assignedUser}
          onChange={assignUser}
          otherAssignedUsers={otherAssignedUsers}
          userActionType={userActionType}
          hasPermissionToAssignCurrentUser={hasPermissionToAssignCurrentUser}
          hasPermissionToAssignOtherUsers={hasPermissionToAssignOtherUsers}
          unassignedLabel={
            unassignedLabel || USER_ASSIGNMENT_LABEL[userActionType]
          }
          isDisabled={isDisabled}
        />
      </div>
    )
  }

  return (
    <UserAssignmentSelect
      tooltip={tooltip}
      assignedUser={assignedUser}
      onChange={assignUser}
      otherAssignedUsers={otherAssignedUsers}
      userActionType={userActionType}
      hasPermissionToAssignCurrentUser={hasPermissionToAssignCurrentUser}
      hasPermissionToAssignOtherUsers={hasPermissionToAssignOtherUsers}
      isDisabled={isDisabled}
    />
  )
}

MenuCurationTaskUserAssignment.propTypes = {
  menuCurationTaskId: PropTypes.string.isRequired,
  userActionType: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  otherAssignedUsers: PropTypes.arrayOf(PropTypes.string),
  assignedUser: PropTypes.object,
  isCheckbox: PropTypes.bool,
  isDisabled: PropTypes.bool,
  unassignedLabel: PropTypes.string,
}

MenuCurationTaskUserAssignment.defaultProps = {
  assignedUser: undefined,
  otherAssignedUsers: [],
  isCheckbox: false,
  tooltip: undefined,
  isDisabled: false,
  unassignedLabel: undefined,
}

export default MenuCurationTaskUserAssignment
